import { render } from "./StageRundown.vue?vue&type=template&id=4f1a4fe8&scoped=true"
import script from "./StageRundown.vue?vue&type=script&lang=js"
export * from "./StageRundown.vue?vue&type=script&lang=js"

import "./StageRundown.vue?vue&type=style&index=0&id=4f1a4fe8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1a4fe8"]])

export default __exports__